import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import layout from "@/store/_layout";
import log from "@/store/_log";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "ghmGraaHz9";

const cookieStorage = new VuexPersistence({
  key: storageKey,
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) =>
    Cookies.set(key, state, {
      expires: 3
    }),
  reducer: state => ({
    user: {
      account: state.user.account,
      account_profile: state.user.account_profile,
      account_authority: state.user.account_authority,
      username: state.user.username,
      loginId: state.user.loginId,
      accountId: state.user.accountId,
      sessionToken: state.user.sessionToken,
      accessRoles: state.user.accessRoles,
      authorityRole: state.user.authorityRole,
      attachmentPath: state.user.attachmentPath,
      daily_statement: state.user.daily_statement,
      win_lose: state.user.win_lose,
      daily_summary_company: state.user.daily_summary_company,
      daily_summary_member: state.user.daily_summary_member,
      game_result: state.user.game_result,
      bonus_list: state.user.bonus_list,
      adjustment_list: state.user.adjustment_list,
      alertOn: state.user.alertOn,
      referee_list: state.user.referee_list
    }
  })
});

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize
    }
  })
});

// const sessionStorage = new VuexPersistence({
//   key: storageKey,
//   storage: window.sessionStorage,
//   reducer: state => ({
//     user: {
//       username: state.user.username,
//       sessionToken: state.user.sessionToken,
//       accessRoles: state.user.accessRoles
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user,
    layout,
    log
  },
  getters: {
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    utmPageSize: state => {
      return state.layout.utmPageSize;
    },
    utmPageSizeOptions: state => {
      return state.layout.utmPageSizeOptions;
    },
    username: state => {
      return state.user.username;
    },
    displayName: state => {
      return state.user.username.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      // return state.user.username;
    },
    accessRoles: state => {
      return state.user.account_authority;
    },
    accessOptions: state => {
      return state.layout.accessList;
    },
    authorityRole: state => {
      return state.user.authorityRole;
    },
    sessionToken: state => {
      return state.user.sessionToken;
    },
    account: state => {
      return state.user.account;
    },
    loginId: state => {
      return state.user.loginId;
    },
    accountId: state => {
      return state.user.accountId;
    },
    accountProfile: state => {
      return state.user.account_profile;
    },
    accountAuthority: state => {
      return state.user.account_authority;
    },
    isLoggedIn: state => {
      if (state.user.sessionToken) {
        return true;
      } else {
        return false;
      }
    },
    isMinimized: state => {
      return state.layout.sidebar.minimized;
    },
    attachmentPath: state => {
      return state.user.attachmentPath;
    },
    dailyStatement: state => {
      return state.user.daily_statement;
    },
    winLose: state => {
      return state.user.win_lose;
    },
    dailySummaryCompany: state => {
      return state.user.daily_summary_company;
    },
    dailySummaryMember: state => {
      return state.user.daily_summary_member;
    },
    gameResult: state => {
      return state.user.game_result;
    },
    bonusList: state => {
      return state.user.bonus_list;
    },
    adjustmentList: state => {
      return state.user.adjustment_list;
    },
    alertOn: state => {
      return state.user.alertOn;
    },
    refereeList: state => {
      return state.user.referee_list;
    },
    winLoseAff: state => {
      return state.user.win_lose_aff;
    },
  },
  plugins: [localStorage.plugin, cookieStorage.plugin]
  // plugins: [localStorage.plugin, sessionStorage.plugin]
});

export default store;
